<ul navAccordion class="matero-sidemenu level-0 m-t-16">
  <li navAccordionLink class="matero-sidemenu-item" routerLinkActive="active"
      *ngFor="let menuItem of menus | async"
      [group]="menuItem.route">
    <a class="matero-sidemenu-link" [routerLink]="sharedService.buildRoute([menuItem.route])"
       *ngIf="menuItem.type === 'link' && (menuItem.visible == undefined || menuItem.visible)"
       >
      <!-- <mat-icon class="menu-icon"><i class="{{menuItem.icon}}"></i></mat-icon> -->
      <span class="menu-name">{{menuItem.name | translate}}</span>
      <span class="menu-label bg-{{menuItem.label.color}}" *ngIf="menuItem.label">
        {{menuItem.label.value}}
      </span>
      <span fxFlex></span>
      <span class="menu-badge bg-{{menuItem.badge.color}}" *ngIf="menuItem.badge">
        {{menuItem.badge.value}}
      </span>
    </a>
    <a class="matero-sidemenu-link" [href]="menuItem.route" *ngIf="menuItem.type === 'extLink'"
       >
      <!-- <mat-icon class="menu-icon"><i class="{{menuItem.icon}}"></i></mat-icon> -->
      <span class="menu-name">{{menuItem.name | translate}}</span>
      <span class="menu-label bg-{{menuItem.label.color}}" *ngIf="menuItem.label">
        {{menuItem.label.value}}
      </span>
      <span fxFlex></span>
      <span class="menu-badge bg-{{menuItem.badge.color}}" *ngIf="menuItem.badge">
        {{menuItem.badge.value}}
      </span>
      <mat-icon class="menu-caret">launch</mat-icon>
    </a>
    <a class="matero-sidemenu-link" [href]="menuItem.route" target="_blank"
       *ngIf="menuItem.type === 'extTabLink'"
       >
      <!-- <mat-icon class="menu-icon"><i class="{{menuItem.icon}}"></i></mat-icon> -->
      <span class="menu-name">{{menuItem.name | translate}}</span>
      <span class="menu-label bg-{{menuItem.label.color}}" *ngIf="menuItem.label">
        {{menuItem.label.value}}
      </span>
      <span fxFlex></span>
      <span class="menu-badge bg-{{menuItem.badge.color}}" *ngIf="menuItem.badge">
        {{menuItem.badge.value}}
      </span>
      <mat-icon class="menu-caret">launch</mat-icon>
    </a>
    <!-- level 1 -->
    <a navAccordionToggle class="matero-sidemenu-toggle" href="javascript:void(0);"
       *ngIf="menuItem.type === 'sub'"
       matRipple [matRippleDisabled]="!ripple">
      <!-- <mat-icon class="menu-icon"><i class="{{menuItem.icon}}"></i></mat-icon> -->
      <span class="menu-name">{{menuItem.name | translate}}<mat-icon class="menu-caret">keyboard_arrow_down</mat-icon></span>
      <span class="menu-label bg-{{menuItem.label.color}}" *ngIf="menuItem.label">
        {{menuItem.label.value}}
      </span>
      <span fxFlex></span>
      <span class="menu-badge bg-{{menuItem.badge.color}}" *ngIf="menuItem.badge">
        {{menuItem.badge.value}}
      </span>
      
    </a>
    <ul navAccordion class="matero-sidemenu submenu level-1" *ngIf="menuItem.type === 'sub'">
      <li navAccordionLink class="matero-sidemenu-item" routerLinkActive="active"
          *ngFor="let childLvl1 of menuItem.children"
          [group]="childLvl1.route">
        <a class="matero-sidemenu-link"
           [routerLink]="sharedService.buildRoute([menuItem.route, childLvl1.route])"
           *ngIf="childLvl1.type === 'link'"
           matRipple [matRippleDisabled]="!ripple">
          <span class="menu-name">{{childLvl1.name | translate}}</span>
        </a>
        <a class="matero-sidemenu-link" [href]="childLvl1.route"
           *ngIf="childLvl1.type === 'extLink'"
           matRipple [matRippleDisabled]="!ripple">
          <span class="menu-name">{{childLvl1.name | translate}}</span>
          <span fxFlex></span>
          <mat-icon class="menu-caret">launch</mat-icon>
        </a>
        <a class="matero-sidemenu-link" [href]="childLvl1.route" target="_blank"
           *ngIf="childLvl1.type === 'extTabLink'"
           matRipple [matRippleDisabled]="!ripple">
          <span class="menu-name">{{childLvl1.name | translate}}</span>
          <span fxFlex></span>
          <mat-icon class="menu-caret">launch</mat-icon>
        </a>
        <!-- level 2 -->
        <a navAccordionToggle class="matero-sidemenu-toggle" href="javascript:void(0);"
           *ngIf="childLvl1.type === 'sub'"
           matRipple [matRippleDisabled]="!ripple">
          <span class="menu-name">{{childLvl1.name | translate}}</span>
          <span fxFlex></span>
          <mat-icon class="menu-caret">arrow_drop_down</mat-icon>
        </a>
        <ul class="matero-sidemenu submenu level-2" *ngIf="childLvl1.type === 'sub'">
          <li class="matero-sidemenu-item" routerLinkActive="active"
              *ngFor="let childLvl2 of childLvl1.children">
            <a class="matero-sidemenu-link"
               [routerLink]="sharedService.buildRoute([menuItem.route, childLvl1.route, childLvl2.route])"
               *ngIf="childLvl2.type === 'link'"
               matRipple [matRippleDisabled]="!ripple">
              <span class="menu-name">{{childLvl2.name | translate}}</span>
            </a>
            <a class="matero-sidemenu-link" [href]="childLvl2.route"
               *ngIf="childLvl2.type === 'extLink'"
               matRipple [matRippleDisabled]="!ripple">
              <span class="menu-name">{{childLvl2.name | translate}}</span>
              <span fxFlex></span>
              <mat-icon class="menu-caret">launch</mat-icon>
            </a>
            <a class="matero-sidemenu-link" [href]="childLvl2.route" target="_blank"
               *ngIf="childLvl2.type === 'extTabLink'"
               matRipple [matRippleDisabled]="!ripple">
              <span class="menu-name">{{childLvl2.name | translate}}</span>
              <span fxFlex></span>
              <mat-icon class="menu-caret">launch</mat-icon>
            </a>
          </li>
        </ul>
      </li>
    </ul>
  </li>
</ul>
<span class="pointer m-t-16" *ngIf="socials && socials.length > 0" style="white-space: nowrap; display: block; text-align: center;">
  <a *ngFor="let social of socials" style="color: var(--color-client-text);margin-left:6px;margin-right:6px" class="matero-toolbar-button  pointer" target="new" href="{{ social.value }}">
        <mat-icon class="pointer" *ngIf="social.icon.includes('svg_')" svgIcon="{{ social.icon }}" style="width: 20px;
        height: 22px;
        font-size: 20px;
        line-height: 20px;"> </mat-icon>
        <mat-icon class="pointer" *ngIf="!social.icon.includes('svg_')"> {{ social.icon }}</mat-icon>
  </a>
  <a *ngIf="entity?.shopUrl != null" style="color: var(--color-client-text);margin-left:6px;margin-right:6px" class="matero-toolbar-button  pointer" target="new" href="{{ entity?.shopUrl }}">
    <mat-icon class="pointer" style="width: 20px;
    height: 22px;
    font-size: 20px;
    line-height: 20px;">shopping_cart</mat-icon>
    
</a>
<a href="https://www.yulava.com/" target="new">
  <img src="{{environment.assetsUrl}}assets/images/icon_yulava.svg" style="height: 22px;margin-bottom:1px;margin-left: 6px;">
</a>
</span>
<div style="display: flex;
flex-direction: column;
gap: 10px;
align-items: center;
text-align: center;
background-color: rgba(0,0,0,0.05);
padding:20px; border-radius: var(--client-radius);
margin: 20px 30px;">

  <span>{{ 'general.member_club' | translate }}</span>
  <a href="https://connect.yulava.com/" target="new">
    <button mat-button 
    style="background-color: var(--color-client);
    color: var(--color-client-text);
    font-size: 0.8rem;
    min-width: 20px;
    height: 24px;
    border-radius: calc(var(--client-radius) + 0px);
    line-height: 0.8rem;
    margin: 10px;
    font-weight: 600;">{{ 'general.access' | translate }}</button></a>
    <span style="margin-bottom: 10px;">{{ 'general.download_app' | translate }}</span>
    <a href="https://play.google.com/store/apps/details?id=com.yulava.connect" target="new" class="app-store-logo">
      <img src="{{environment.assetsUrl}}assets/icons/android.svg" title="Google Play" alt="Google Play" style="height: 30px;border-radius: var(--client-radius);">
  </a>
  <a href="https://apps.apple.com/es/app/yulava-connect/id1533240784" target="new" class="app-store-logo">
      <img src="{{environment.assetsUrl}}assets/icons/ios.svg" title="App Store" alt="App Store" style="height: 30px;border-radius: var(--client-radius);">
  </a>
</div>
